import BaseHandler from "../BaseHandler";
import { ClientRoomChangeOwner } from "../../proto/ClientRoomChangeOwner_pb";

export default class HandleClientRoomChangeOwner extends BaseHandler<ClientRoomChangeOwner> {
  handle() {}
}
